import React from "react";
import ComponentWrapper from "../ComponentWrapper";
import { Link } from "react-router-dom";
import AddHLXButton from "../AddHLXButton";

const Footer = () => {
  return (
    <footer className="pt-14 sm:pt-20 pb-5">
      <ComponentWrapper>
        <div className="w-full bg-blue-2 rounded-[24px] px-4 md:px-8 flex flex-col">
          <div className="w-full pt-5 md:pt-10 grid gap-10 grid-cols-1 md:grid-cols-[1fr_1fr]">
            {/* left section */}
            <div className="w-full gap-5 flex flex-col">
              <div className="w-full flex justify-between items-center">
                <img
                  src="/assets/white-logo.svg"
                  alt=""
                  className="w-[97px] h-[25px] hover:opacity-80 transition-opacity duration-200"
                />
                <a
                  href="https://ai.helix.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" md:hidden flex border-[1px] border-gray-2 rounded-[12px] h-[36px] px-6 justify-center items-center gap-2 
                      hover:bg-gray-50 bg-white hover:border-gray-300 transition-all duration-200 ease-in-out
                      active:scale-95 transform"
                >
                  <img
                    src="/assets/black-logo.svg"
                    alt=""
                    className="w-[18px] h-[16px] transition-transform duration-200 hover:scale-110"
                  />
                  <p className="text-[14px] whitespace-nowrap font-semibold text-blue-1 transition-colors duration-200">
                    Launch App
                  </p>
                </a>
              </div>
              <p className="text-[14px] sm:block hidden max-w-[380px] text-white/70 font-medium">
                Helix AI is an autonomous Ethereum AI agent. Deploy contracts,
                swap tokens, transfer assets, and manage your portfolio through
                natural language.
              </p>
              <div className="hidden md:flex items-center gap-5">
                <a href="https://t.me/Helix" target="_blank" rel="noopener noreferrer">
                  <img
                    src="/icons/tele.svg"
                    alt="Telegram"
                    className="w-[20px] hover:scale-105 transition-all duration-200 h-[20px]"
                  />
                </a>
                <a href="https://x.com/Helix" target="_blank" rel="noopener noreferrer">
                  <img
                    src="/icons/x.svg"
                    alt="X (Twitter)"
                    className="w-[20px] hover:scale-105 transition-all duration-200 h-[20px]"
                  />
                </a>
              </div>
              <div className="hidden md:block">
                <AddHLXButton ensureEthereumNetwork={true} />
              </div>
            </div>
            {/* right section */}
            <div className="w-full grid grid-cols-2 md:grid-cols-3">
              {footerData.map((item, index) => (
                <div key={index} className="w-full flex flex-col gap-3 sm:gap-4">
                 <p className="text-white text-[18px] font-normal ">{item.title}</p>
                  {item.links.map((lnk, idx) => {
                    // Render external links (like Whitepaper) as <a> tags with target="_blank"
                    if (lnk.path.startsWith('http://') || lnk.path.startsWith('https://')) {
                      return (
                        <a
                          className={`text-white/75 hover:text-white transition-all duration-200 font-normal text-[14px]`}
                          key={idx}
                          href={lnk.path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {lnk.name}
                        </a>
                      );
                    }
                    // Render anchor links (like #faq) with smooth scroll
                    if (lnk.path.startsWith('#')) {
                      return (
                        <a
                          className={`text-white/75 hover:text-white transition-all duration-200 font-normal text-[14px] cursor-pointer`}
                          key={idx}
                          href={lnk.path}
                          onClick={(e) => {
                            e.preventDefault();
                            const element = document.getElementById(lnk.path.substring(1));
                            if (element) {
                              const offset = 84; // navbar height
                              const elementPosition = element.getBoundingClientRect().top;
                              const offsetPosition = elementPosition + window.pageYOffset - offset;
                              window.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                              });
                            }
                          }}
                        >
                          {lnk.name}
                        </a>
                      );
                    }
                    // Render internal links as Link components
                    return (
                      <Link
                        className={`text-white/75 hover:text-white transition-all duration-200 font-normal text-[14px]`}
                        key={idx}
                        to={lnk.path}
                      >
                        {lnk.name}
                      </Link>
                    );
                  })}
                </div>
              ))}
              <div className="">
                <a
                  href="https://ai.helix.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hidden md:flex border-[1px] border-gray-2 rounded-[12px] h-[36px] px-6 justify-center items-center gap-2 
                      hover:bg-gray-50 bg-white hover:border-gray-300 transition-all duration-200 ease-in-out
                      active:scale-95 transform"
                >
                  <img
                    src="/assets/black-logo.svg"
                    alt=""
                    className="w-[18px] h-[16px] transition-transform duration-200 hover:scale-110"
                  />
                  <p className="text-[14px] whitespace-nowrap font-semibold text-blue-1 transition-colors duration-200">
                    Launch App
                  </p>
                </a>
              </div>
              <div className="flex md:hidden pt-8 col-span-2 items-center justify-center gap-5">
                <a href="https://t.me/Helix" target="_blank" rel="noopener noreferrer">
                  <img
                    src="/icons/tele.svg"
                    alt="Telegram"
                    className="w-[20px] h-[20px]"
                  />
                </a>
                <a href="https://x.com/Helix" target="_blank" rel="noopener noreferrer">
                  <img src="/icons/x.svg" alt="X (Twitter)" className="w-[20px] h-[20px]" />
                </a>
              </div>
              <div className="flex md:hidden pt-6 col-span-2 justify-center">
                <AddHLXButton ensureEthereumNetwork={true} />
              </div>
            </div>
          </div>
          <div className="pb-5 pt-5 md:pt-12 flex flex-col gap-4">
            <hr className="w-full h-[1px] bg-white/70" />
            <p className="text-[13px] text-white/50 text-center">
              &copy; {new Date().getFullYear()} Helix AI. All rights reserved.
            </p>
          </div>
        </div>
      </ComponentWrapper>
    </footer>
  );
};

export default Footer;

const footerData = [
  {
    title:'Helix AI',
    links: [
      {
        path: "#about",
        name: "Features",
      },
      {
        path: "https://ai.helix.org",
        name: "Launch App",
      },
      {
        path: "#hlx",
        name: "HLX Token",
      },
      {
        path: "#governance",
        name: "Community",
      },
      {
        path: "/docs/whitepaper",
        name: "Whitepaper",
      },
    ],
  },
  {
     title:'Resources',
    links: [
      {
        path: "/docs",
        name: "Documentation",
      },
      {
        path: "#faq",
        name: "FAQ",
      },
      {
        path: "/terms",
        name: "Terms of Service",
      },
      {
        path: "/privacy",
        name: "Privacy Policy",
      },
    ],
  },
];
